import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Eye = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9C10.2957 9 8.99248 10.3 8.99248 12C8.99248 13.7 10.2957 15 12 15C13.7043 15 15.0075 13.7 15.0075 12C15.0075 10.3 13.7043 9 12 9ZM21.9248 11.6C19.9198 6.9 16.1103 4 12 4C7.88973 4 4.0802 6.9 2.07519 11.6C1.97494 11.9 1.97494 12.1 2.07519 12.4C4.0802 17.1 7.88973 20 12 20C16.1103 20 19.9198 17.1 21.9248 12.4C22.0251 12.1 22.0251 11.9 21.9248 11.6ZM12 17C9.19298 17 6.98747 14.8 6.98747 12C6.98747 9.2 9.19298 7 12 7C14.807 7 17.0125 9.2 17.0125 12C17.0125 14.8 14.807 17 12 17Z"
      fill="currentColor"
    />
  </svg>
)

export default Eye
